<template>
  <div class="footer">
    <div class="bats">
      <a href="https://beian.miit.gov.cn/" target="_blank"  class="bah">粤ICP备20020968号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    toAboutUs() {
      this.$router.push({ path: "/about" });
    },
    // 跳转到梳化
    toSf() {
      this.$router.push({ path: "/goods/sf" });
    },
    // 跳转到床墊
    toCd() {
      this.$router.push({ path: "/goods/cd" });
    },
    // 跳转到床品
    toCp() {
      this.$router.push({ path: "/goods/cp" });
    },
    toContact() {
      this.$router.push({ path: "/contact" });
    },
  },
};
</script>

<style scoped>
.bats {
  width: 100%;
  height: 100px;
  background-image: url('../assets/picture/footer.jpg');
}

.dutable {
  height: 280px;
  width: 1100px;
  margin: 0px auto;
}
.el-col {
  margin-top: 50px;
}

.dutitle {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  height: 50px;
  line-height: 50px;
}
.ducontant {
  font-size: 12px;
  color: #b5b5b9;
  height: 24px;
  line-height: 24px;
}

.bats {
  font-size: 13px;
  height: 65px;
  line-height: 60px;
  color: #ffffff;
}

/* 微信二维码 */
.wx {
  width: 90px;
  height: 90px;
}
.dzt {
  text-align: left;
  margin-left: 30px;
}
.dz {
  text-align: left;
  margin-left: 20px;
}

.bah
{
  color: #ffff;
}
</style>